export interface VariantCalculations {
    insuranceWage: number;
    socialInsuranceWorkerShare: number;
    salaryTax: number;
    martyrsFamiliesFunds: number;
    socialInsuranceEmployerShare: number;
    totalDeduction: number;
}
export enum LawYear {
    TWENTY_TWO = "2022",
    TWENTY_THREE = "2023",
    TWENTY_FOUR = "2024",
    TWENTY_FIVE = "2025",
    TWENTY_SIX = "2026",
}
